module.exports = __webpack_public_path__ + "img/logo.9052ab8c.png";